import {StringIDFolder} from 'constants/FolderConstants';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import {Comment, FromServerProtocol, FromServerProtocolVersion} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import * as net from 'util/Net';
import type {BetterJQueryPromise} from 'util/Promises';

function get(id: string): BetterJQueryPromise<FromServerProtocol> {
  // TODO(eln) remove
  // Skips for experimental protocols.
  let args = {};
  if (id.indexOf('eprt_') !== 0) {
    args = {view: true};
  }

  return net.getJSONTracked(`/1/api/protocols/${id}`, args);
}

function getVersions(id: string): JQueryPromise<FromServerProtocolVersion> {
  return net.getJSON(`/1/api/protocols/${id}/versions/`);
}

function getVersion(id: string, versionId: number): JQueryPromise<Array<FromServerProtocolVersion>> {
  return net.getJSON(`/1/api/protocols/${id}/versions/${versionId}`);
}

function delete_(id: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/protocols/${id}`});
}

function update(
  id: string,
  data: {tagSchemaId: string | null}
): JQueryPromise<{cidIdMap: CidIdMap; editURL: string; folder: StringIDFolder}> {
  return net.patchJSON({
    url: `/1/api/protocols/${id}`,
    data,
  });
}

function create(
  param: {name?: string; folder?: string; sharing?: string} = {}
): JQueryPromise<FromServerProtocol> {
  const {name, folder} = param;
  return net
    .postJSON({
      url: '/1/api/protocols/',
      data: {name, folder},
    })
    .done(() => {
      FolderDAOCache.invalidateFolderContents(folder);
    });
}

function comment(
  protocolID: string,
  {
    text,
    linkableID,
    linkType,
    onDescription,
  }: {
    linkableID: string;
    linkType: string;
    onDescription: boolean;
    text: string;
  }
): JQueryPromise<Comment> {
  return net.postJSON({
    url: `/1/api/protocols/${protocolID}/comments/`,
    data: {
      text,
      link_id: linkableID,
      link_type: linkType,
      on_description: onDescription,
    },
  });
}

function deleteComment(protocolID: string, commentID: number): JQueryPromise<{}> {
  return net.delete_({
    url: `/1/api/protocols/${protocolID}/comments/${commentID}`,
  });
}

function completeStep(protocolID: string, stepID: number | string): JQueryPromise<{}> {
  return net.postJSON({
    url: `/1/api/protocols/${protocolID}/steps/${stepID}/complete`,
  });
}

function resetStep(protocolID: string, stepID: number | string): JQueryPromise<{}> {
  return net.delete_({
    url: `/1/api/protocols/${protocolID}/steps/${stepID}/complete`,
  });
}

function resetAllSteps(protocolID: string): JQueryPromise<{}> {
  return resetStep(protocolID, 'all');
}

export default {
  get,
  getVersion,
  getVersions,
  delete: delete_,
  update,
  create,
  comment,
  deleteComment,
  completeStep,
  resetStep,
  resetAllSteps,
};
